module.exports = __webpack_public_path__ + "img/6.c19114b5.jpg";